// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStatusIndicator-LoadingContainer_cls1__b0oZY","cls2":"VeloStatusIndicator-LoadingContainer_cls2__z7orU VeloStatusIndicator-LoadingContainer_cls1__b0oZY"};